import React from "react";
import AlumniSpeak from "./AlumniSpeak";
import YourCareer from "../Program/ProgramDetails/YourCareer";
import ReviewsCategories from "./ReviewsCategories";
import ExploreTopCourses from "./ExploreTopCourses";
import Faq from "../Faq/Faq";
import Navbar from "../About/Navbar";
const AlumniSpeakMain = () => {
  return (
    <div className="mt-24">
        <Navbar />
        <AlumniSpeak/>
        <YourCareer/>
        <ReviewsCategories/>
        <ExploreTopCourses/>
        <Faq />
    </div>
  );
};

export default AlumniSpeakMain;